import { createRouter } from "@tanstack/react-router";
import { routeTree } from "@/app/router/routeTree";
import type { RouterContext } from "@/app/router/types";

export const createAppRouter = (context: RouterContext) =>
  createRouter({
    routeTree,
    context,
    defaultPreload: "intent",
  });

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module "@tanstack/react-router" {
  interface Register {
    router: AppRouter;
  }
  interface StaticDataRouteOption {
    title?: string;
  }
}
